// const hero = new Swiper(".swiperHero", {
//     // autoplay: true,
//     slidesPerView: 1,
//     pagination: {
//         el: ".swiper-pagination",
//         clickable: true,
//     },
// })


let swiperImage = new Swiper(".heroImage", {

    slidesPerView: 1,
});

let swiperHero = new Swiper(".heroSwiper", {
    effect: "fade",
    fadeEffect: { // Add this
        crossFade: true,
    },
    slidesPerView: 1,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    thumbs: {
        swiper : swiperImage
    }
});
